import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { Observable, BehaviorSubject } from 'rxjs';
import { Store } from '@ngrx/store';

import { UrlFactoryService } from '../services/url-factory.service';
import { MonitoredHttpService as Http } from '../services/monitored-http.service';

export interface DirectorConnectionState {
  director?: 'unknown' | 'initializing' | 'parsing' | 'connected' | 'disabled';
  driverCacheProgress?: number;
  programmingCacheProgress?: number;
}

export const DIRECTOR_CONNECTION_INITIAL_STATE: DirectorConnectionState = {}

const STORE_NAME = 'DIRECTOR_CONNECTION';

export const DIRECTOR_CONNECTION_ACTIONS = {
  SET_DIRECTOR: `${STORE_NAME}:SET_DIRECTOR`,
  CLEAR: `${STORE_NAME}:CLEAR`
}

export const DIRECTOR_CONNECTION_STRINGS = Object.keys(DIRECTOR_CONNECTION_ACTIONS).map(key => DIRECTOR_CONNECTION_ACTIONS[key]);

export function directorConnectionReducer(state: DirectorConnectionState = DIRECTOR_CONNECTION_INITIAL_STATE, {type, payload}) {

  // if (DIRECTOR_CONNECTION_STRINGS.indexOf(type) > -1) {
  //   console.info('type: %s, payload: %O', type, payload);
  // }

  switch (type) {
    case DIRECTOR_CONNECTION_ACTIONS.SET_DIRECTOR:
      return Object.assign({}, payload);

    case DIRECTOR_CONNECTION_ACTIONS.CLEAR:
      return Object.assign({}, DIRECTOR_CONNECTION_INITIAL_STATE);

    default:
      return state;
  }
}

@Injectable()
export class DirectorConnectionService {

  // How often to ping /status, in ms
  private _interval = 5000;

  constructor(
    private _store: Store<{ directorConnection: DirectorConnectionState }>,
    private _http: Http,
    private _url: UrlFactoryService
  ) {

    Observable.timer(0, this._interval).flatMap(t => {
      return <Observable<Response>>_http.get(_url.getBrokerURL('/api/v1/status'))
        .timeout(this._interval)
        .catch((err, caught) => {
          return this._unknownStatus();
        })
    })
      .filter(r => !!r)
      .map(r => r.json())
      .subscribe(status => this._store.dispatch({
        type: DIRECTOR_CONNECTION_ACTIONS.SET_DIRECTOR,
        payload: status
      }))
  }

  private _unknownStatus = (): Observable<{}> => {
    this._store.dispatch({
      type: DIRECTOR_CONNECTION_ACTIONS.SET_DIRECTOR,
      payload: {
        director: 'unknown'
      }
    });

    return Observable.empty();
  }

}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/director-connection/director-connection.service.ts